import { getCurrentUserScope } from "../services/userScopedStorage";

// The browser remembers which session an audio file was being uploaded to,
// so that choosing the same file again after the upload broke off, even in a
// new tab, continues that upload instead of starting over. Keyed by user and
// by the file's name, size and modification time: the blocks Azure kept are
// only reused for the very same file. Without storage nothing is resumed.
const KEY_PREFIX = "pendingAudioUpload";

const scopePrefix = () => `${KEY_PREFIX}::${getCurrentUserScope()}::`;

const keyFor = (file) =>
  `${scopePrefix()}${file.name}|${file.size}|${file.lastModified}`;

const sessionUnder = (key) => {
  try {
    const stored = JSON.parse(localStorage.getItem(key) || "null");
    return stored?.sessionId ?? null;
  } catch {
    return null;
  }
};

// A session holds one audio file: once another file goes to it, what was
// remembered for earlier files no longer leads there.
const forgetOthersFor = (sessionId, keep) => {
  const prefix = scopePrefix();
  const keys = [];
  for (let i = 0; i < localStorage.length; i += 1) keys.push(localStorage.key(i));
  keys
    .filter((key) => key && key !== keep && key.startsWith(prefix))
    .filter((key) => String(sessionUnder(key)) === String(sessionId))
    .forEach((key) => localStorage.removeItem(key));
};

export const rememberUpload = (file, sessionId) => {
  try {
    forgetOthersFor(sessionId, keyFor(file));
    localStorage.setItem(keyFor(file), JSON.stringify({ sessionId }));
  } catch {
    // Ignore storage access errors.
  }
};

export const pendingUploadFor = (file) => {
  try {
    return sessionUnder(keyFor(file));
  } catch {
    return null;
  }
};

export const forgetUpload = (file) => {
  try {
    localStorage.removeItem(keyFor(file));
  } catch {
    // Ignore storage access errors.
  }
};
